import { createContext, useContext, useState } from "react";
import userProfileImg from '../../admin-candidate/candiate-info-nav/img/avatar.png';
import axios from "axios";
import { decodeJWT } from "../../../../services/candidateService";
import { UserService } from "../../../../services/userService";
import { serverConfig } from "../../../../services/server-config";
import { useEffect } from "react";
const ProfileImageContext = createContext();

export const ProfileImageProvider = ({ children }) => {
    const [profileImageUrl, setProfileImageUrl] = useState(userProfileImg);
    const [loading, setLoading] = useState(false);

    const fetchProfileImage = async (dpPath) => {
        if (!dpPath) {
            setProfileImageUrl(userProfileImg);
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const token = localStorage.getItem("authToken");
            const url = `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${encodeURIComponent(dpPath)}&t=${Date.now()}`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: "blob",
            });
            const imageBlob = new Blob([response.data], { type: response.headers["content-type"] });
            setProfileImageUrl(URL.createObjectURL(imageBlob));
        } catch (error) {
            console.error("Error fetching profile image:", error);
            setProfileImageUrl(userProfileImg);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const decoded = decodeJWT(token);
        if (!decoded?.username) return;

        setLoading(true);
        UserService.getUserDetails(decoded.username)
            .then((res) => {
                const userData = res.data?.users?.[0];
                fetchProfileImage(userData?.dpPath);
            })
            .catch(() => {
                setProfileImageUrl(userProfileImg);
                setLoading(false);
            });
    }, []);

    return (
        <ProfileImageContext.Provider value={{ profileImageUrl, setProfileImageUrl, fetchProfileImage, loading, setLoading }}>
            {children}
        </ProfileImageContext.Provider>
    );
};

export const useProfileImage = () => useContext(ProfileImageContext);